import React from 'react';
import { resetEditorChromes } from '..';
export const withEditorChromes = (WrappedComponent) => {
    class Enhancer extends React.Component {
        constructor() {
            super(...arguments);
            this.displayName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
        }
        componentDidUpdate() {
            resetEditorChromes();
        }
        render() {
            return React.createElement(WrappedComponent, Object.assign({}, this.props));
        }
    }
    return Enhancer;
};
